import React from "react";
import "./EndOfDay.scss";

interface EndOfDayProps {
  day: number;
  today?: boolean;
}

const EndOfDay: React.FC<EndOfDayProps> = ({ day, today }) => {
  const christmas: boolean = day >= 25;
  const nextDay: string = (day + 1).toString();
  return (
    <div className="end-of-day">
      <h2>{`End of Part ${day}`}</h2>
      {day == 4 ? (
        <p>
          Thank you for playing our Demo. We hope to see you for the full
          adventure this year!
        </p>
      ) : (
        <a href={"/adventure/demo/" + nextDay}>Go to next day</a>
      )}
      {/* )} */}
    </div>
  );
};

export default EndOfDay;
